module.exports = __webpack_public_path__ + "img/lock.c2cc5d1f.svg";